export const FETCH_LIST_DOCTORS_REQUEST= "FETCH_LIST_DOCTORS_REQUEST";
export const FETCH_LIST_DOCTORS_SUCCESS= "FETCH_LIST_DOCTORS_SUCCESS";
export const FETCH_LIST_DOCTORS_FAILURE= "FETCH_LIST_DOCTORS_FAILURE";

// View single doctor
export const FETCH_DOCTOR_REQUEST= "FETCH_DOCTOR_REQUEST";
export const FETCH_DOCTOR_SUCCESS= "FETCH_DOCTOR_SUCCESS";
export const FETCH_DOCTOR_FAILURE= "FETCH_DOCTOR_FAILURE";

// Add doctor
export const ADD_DOCTOR_REQUEST= "ADD_DOCTOR_REQUEST";
export const ADD_DOCTOR_SUCCESS= "ADD_DOCTOR_SUCCESS";
export const ADD_DOCTOR_FAILURE= "ADD_DOCTOR_FAILURE";

// Edit doctor
export const UPDATE_DOCTOR_REQUEST= "UPDATE_DOCTOR_REQUEST";
export const UPDATE_DOCTOR_SUCCESS= "UPDATE_DOCTOR_SUCCESS";
export const UPDATE_DOCTOR_FAILURE= "UPDATE_DOCTOR_FAILURE";

// Delete doctor
export const DELETE_DOCTOR_REQUEST= "DELETE_DOCTOR_REQUEST";
export const DELETE_DOCTOR_SUCCESS= "DELETE_DOCTOR_SUCCESS";
export const DELETE_DOCTOR_FAILURE= "DELETE_DOCTOR_FAILURE";

// Reset current doctor
export const RESET_CURRENT_DOCTOR= "RESET_CURRENT_DOCTOR";

export const HISTORY_DOCTORS_REQUEST="HISTORY_DOCTORS_REQUEST";
export const HISTORY_DOCTORS_SUCCESS="HISTORY_DOCTORS_SUCCESS";
export const HISTORY_DOCTORS_FAILURE="HISTORY_DOCTORS_FAILURE";